import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AnnouncementService {
    private _show$ = new Subject<void>();
    readonly show$ = this._show$.asObservable();

    private _isOpen = false;

    get isOpen(): boolean { return this._isOpen; }
    setOpen(val: boolean): void { this._isOpen = val; }

    show(): void {
        this._show$.next();
    }
}